import { render, staticRenderFns } from "./vertical-ranking-adjusting.vue?vue&type=template&id=71cba124&"
import script from "./vertical-ranking-adjusting.vue?vue&type=script&lang=js&"
export * from "./vertical-ranking-adjusting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports